import { render, staticRenderFns } from "./offerte.html?vue&type=template&id=5c74d32a&"
import script from "./Offerte.vue?vue&type=script&lang=js&"
export * from "./Offerte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports